export function spacesToNonBreakingSpaces(s: string): string {
  return s.replace(' ', '\xa0');
}
